<div
    #containerRef
    class="badge-list-wrapper"
    [style]="{ width: badgeListConfig.width, height: badgeListConfig.height }"
>
    <div class="badge-list-container" [style]="{ justifyContent: badgeListConfig.position }">
        <fcp-badge
            [class]="badge.size === badgeSizeEnum.SmallRound ? 'badge-list-counter' : 'badge-list-element'"
            *ngFor="let badge of visibleBadges | async"
            [size]="badge.size ?? badgeSizeEnum.Small"
            [inversed]="badgeListConfig.inversed"
            [ngStyle]="{ maxWidth: badge.maxWidth ?? '' }"
        >
            <ng-container *ngIf="badge.size === badgeSizeEnum.SmallRound">
                <span
                    #container="cdkOverlayOrigin"
                    cdkOverlayOrigin
                    class="tooltip-container"
                    (mouseenter)="toggleTooltip(true)"
                    (mouseleave)="toggleTooltip(false)"
                ></span>
                <fcp-tooltip
                    *ngIf="badgeListConfig.tooltip.enabled && !!(tooltip | async)"
                    [customPosition]="tooltipPosition"
                    [open]="showTooltipSubject | async"
                    [overlayOrigin]="container"
                >
                    <div class="fc-brand-info-tooltip" [style]="{ maxWidth: badgeListConfig.tooltip.maxWidth }">
                        {{ tooltip | async }}
                    </div>
                </fcp-tooltip>
            </ng-container>
            <div class="badge-content">
                <span *ngIf="badge.logo">
                    <fcp-icon [icon]="badge.logo"></fcp-icon>
                </span>
                <span [title]="badge.text">
                    {{ badge.text }}
                </span>
            </div>
        </fcp-badge>
    </div>
</div>
